// Reserved usernames that cannot be used as they conflict with app routes
export const RESERVED_USERNAMES = [
  // Core app routes
  "home",
  "profile",
  "friends",
  "pro",
  "login",
  "confirmation",

  // Settings routes
  "settings-profile",
  "settings-notifications",
  "settings-overview",
  "settings",

  // Onboarding routes
  "onboarding-start",
  "onboarding-one",
  "onboarding-one-twenty-five",
  "onboarding-one-five",
  "onboarding-two",
  "onboarding-three",
  "onboarding-notifications",
  "onboarding",

  // Auth routes
  "save-account",
  "firebaseauth",
  "download-app",
  "download",
  "age-restriction",

  // Legal routes
  "terms-of-service",
  "privacy-policy",
  "delete-my-data",
  "terms",
  "privacy",

  // Quiz routes
  "political-alignment",
  "best-date",
  "personality-check",
  "sex-styles",
  "attachment-styles",
  "affection-profile",
  "am-i-gay",

  // Other routes
  "shared-answers",
  "results",
  "question",
  "landing",

  // Common reserved words (good practice)
  "admin",
  "administrator",
  "moderator",
  "support",
  "help",
  "api",
  "www",
  "mail",
  "email",
  "webmaster",
  "info",
  "contact",
  "about",
  "vibe",
  "vibecheck",
  "vibecheckme",
  "official",
  "staff",
  "team",
];

/**
 * Checks if a username is reserved and cannot be used
 * @param {string} username - The username to check (case insensitive)
 * @returns {boolean} - True if username is reserved, false otherwise
 */
export const isReservedUsername = (username) => {
  if (!username) return false;
  const normalizedUsername = username.trim().toLowerCase();
  return RESERVED_USERNAMES.includes(normalizedUsername);
};

/**
 * Gets a user-friendly error message for reserved usernames
 * @param {string} username - The reserved username
 * @returns {string} - Error message
 */
export const getReservedUsernameError = (username) => {
  return `The username "${username}" is reserved and cannot be used. Please choose a different username.`;
};

/**
 * Checks if a username contains spaces (usernames should be one word)
 * @param {string} username - The username to check
 * @returns {boolean} - True if username contains spaces, false otherwise
 */
export const hasSpaces = (username) => {
  if (!username) return false;
  return /\s/.test(username);
};

/**
 * Validates username format and returns error message if invalid
 * @param {string} username - The username to validate
 * @returns {string|null} - Error message if invalid, null if valid
 */
export const validateUsername = (username) => {
  if (!username || username.trim() === "") {
    return null; // Empty username is handled elsewhere
  }

  const trimmedUsername = username.trim();

  // Check for spaces
  if (hasSpaces(trimmedUsername)) {
    return "Username must be one word without spaces.";
  }

  // Check if reserved
  if (isReservedUsername(trimmedUsername)) {
    return getReservedUsernameError(trimmedUsername);
  }

  return null; // Username is valid
};
